query RefundsList($page: Int, $rowsPerPage: Int, $filter: RefundsFilterInput) {
  refunds(page: $page, rowsPerPage: $rowsPerPage, filter: $filter) {
    count
    nodes {
      id
      amount {
        value
        currency
      }
      organizationAmountInOrganizationCurrency {
        value
        currency
      }
      status
      manual
      createdAt
      payment {
        buyerEmail
        userId
        provider
        product {
          id
          title
          type
        }
      }
    }
  }
}
